var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Continuar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Simulações" } }),
      _c(
        "div",
        { staticStyle: { height: "55vh" } },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center",
                  staticStyle: { height: "100%" }
                },
                [
                  _c("v-progress-circular", {
                    attrs: { color: "primary", size: 50, indeterminate: "" }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.loading
            ? _c(
                "v-list",
                {
                  staticStyle: { overflow: "auto" },
                  attrs: { height: "55vh" }
                },
                [
                  _c(
                    "v-list-item-group",
                    _vm._l(_vm.simulacoes, function(s) {
                      return _c(
                        "v-list-item",
                        {
                          key: s.hash_code,
                          on: {
                            click: function($event) {
                              return _vm.openSimulation(s)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _c(
                                  "small",
                                  { staticStyle: { "white-space": "initial" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(s.nome_cliente || "Cliente") +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c("v-list-item-subtitle", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex" },
                                  [
                                    _c("small", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.status[s.status_simulacao] ||
                                              s.status_simulacao
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _c("v-spacer"),
                                    _c("small", [
                                      _vm._v(
                                        " Data: " +
                                          _vm._s(s.data_simulacao) +
                                          " "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              s.status_simulacao === "100"
                                ? _c("v-progress-linear", {
                                    attrs: {
                                      indeterminate: "",
                                      stream: true,
                                      striped: ""
                                    }
                                  })
                                : _c("hr")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }